/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AccesscontrolRoles200,
  GetApiV1AccesscontrolRoles401,
  GetApiV1AccesscontrolRoles500,
  GetApiV1AccesscontrolRolesQueryResponse,
} from "../../types/accessControlUsersController/GetApiV1AccesscontrolRoles.ts";
import { roleViewModelSchema } from "../roleViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AccesscontrolRoles200Schema = z.array(
  z.lazy(() => roleViewModelSchema),
) as unknown as ToZod<GetApiV1AccesscontrolRoles200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AccesscontrolRoles401Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolRoles401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AccesscontrolRoles500Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolRoles500>;

export const getApiV1AccesscontrolRolesQueryResponseSchema = z.lazy(
  () => getApiV1AccesscontrolRoles200Schema,
) as unknown as ToZod<GetApiV1AccesscontrolRolesQueryResponse>;
